import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCoursesApi } from '../api/allApi';

export const fetchCourses = createAsyncThunk(
    'courses/fetchCourses',
    async (_, { rejectWithValue }) => {
        try {
            return await getCoursesApi();
        } catch (err) {
            return rejectWithValue(err?.response?.data?.message || 'Failed to fetch courses');
        }
    }
);

const coursesSlice = createSlice({
    name: 'courses',
    initialState: { data: null, fetchLoading: false, error: null },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCourses.pending, (state) => {
                state.fetchLoading = true;
                state.error = null;
            })
            .addCase(fetchCourses.fulfilled, (state, action) => {
                state.fetchLoading = false;
                state.data = action.payload;
            })
            .addCase(fetchCourses.rejected, (state, action) => {
                state.fetchLoading = false;
                state.error = action.payload;
            });
    },
});

export default coursesSlice.reducer;